import { array, func, number, object, string } from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import MenuInput from './MenuInput';
import SubTabs from './SubTabs';
import { ArrowBottom, ArrowRight } from 'components/icons';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DragIcon from '@mui/icons-material/DragHandle';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import getItemStyle from '../styles/getItemStyle';
import { Tab as ConstTab } from '../const';
import sty from '../styles/Tabs.module.css';

/**
 * @component Tab
 * @param { Object } props
 * @param { number } props.index
 * @param { string } props.groupId
 * @param { Object } props.tab
 * @param { string } props.tab.groupId
 * @param { string } props.tab.id
 * @param { string } props.tab.name
 * @param { string } props.tab.url
 * @param { string } props.tab.desc
 * @param { string } props.tab.order
 * @param { array } props.tab.subtabs
 * @param { string } props.tab.subtabId
 * @param { boolean } props.tab.checked
 * @param { boolean } props.tab.open
 * @param { array } props.tabs
 * @param { object } props.savingState
 * @param { object } props.savingHandler
 * @param { array } props.groupTabs
 * @param { function } props.onCheck
 * @param { function } props.onHandle
 * @param { function } props.onToggle
 * @param { function } props.onMenu
 * @param { object } props.handleSubtab
 * @returns { JSX.Element }
 */
function Tab(props) {
	return (
		<Draggable key={props.tab.id} index={props.index} draggableId={props.tab.id}>
			{(provided, snapshot) => (
				<section
					ref={provided.innerRef}
					{...provided.draggableProps}
					className={sty.tab_section}
					style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
				>
					<div className={sty.tab_tab}>
						<Tooltip arrow title="Drag and Drop">
							<IconButton {...provided.dragHandleProps}>
								<DragIcon />
							</IconButton>
						</Tooltip>
						{props.tab.url === 'Sub-menu' ? (
							<IconButton onClick={() => props.onToggle(props.tab.id)}>
								{props.tab.open ? <ArrowBottom /> : <ArrowRight />}
							</IconButton>
						) : (
							<IconButton className={sty.hidden_icon}>
								<ArrowBottom />
							</IconButton>
						)}
						<Checkbox checked={props.tab.checked} onClick={() => props.onCheck(props.tab.id)} />
						<MenuInput
							id={props.tab.id}
							name={ConstTab.Name}
							value={props.tab.name}
							onHandle={props.onHandle}
						/>
						<MenuInput
							id={props.tab.id}
							name={ConstTab.Url}
							value={props.tab.url}
							onHandle={props.onHandle}
						/>
						<MenuInput
							id={props.tab.id}
							name={ConstTab.Desc}
							value={props.tab.desc}
							onHandle={props.onHandle}
						/>
						<MenuInput
							id={props.tab.id}
							name={ConstTab.Order}
							value={props.tab.order}
							onHandle={props.onHandle}
						/>
					</div>
					<SubTabs
						open={props.tab.open}
						groupId={props.groupId}
						subtabId={props.tab.id}
						tabs={props.tabs}
						subtabs={props.tab.subtabs}
						onMenu={props.onMenu}
						savingState={props.savingState}
						savingHandler={props.savingHandler}
						groupTabs={props.groupTabs}
						handleSubtab={props.handleSubtab}
					/>
					<Divider className={sty.divider} />
				</section>
			)}
		</Draggable>
	);
}

Tab.propTypes = {
	index: number,
	groupId: string,
	tab: object,
	tabs: array,
	savingState: object,
	savingHandler: object,
	groupTabs: array,
	onCheck: func,
	onHandle: func,
	onToggle: func,
	onMenu: func,
	handleSubtab: object,
};

export default Tab;
